import { makeStyles } from 'tss-react/mui';

const useStylesWidget: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  widget: {
    display: 'block',
    width: 'calc(50% - 10px)',
    height: 345,
    marginBottom: 20,
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      width: '100%',
    },
  },
  widgetFullHeight: {
    height: 'auto',
  },
  widgetFullWidth: {
    width: '100%',
  },
  widgetNoHeader: {
    marginBottom: -5,
  },
  widgetCardContent: {
    marginTop: -10,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  widgetHeader: {
    backgroundColor: theme.palette.secondary.dark,
    marginBottom: 12,
    height: '100%',
    padding: 5,
    paddingLeft: '30px !important',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '15px !important',
    },
  },
  widgetHeaderCustom: {
    height: 'auto !important',
    paddingLeft: '16px !important',
    paddingRight: '16px !important',
  },
  widgetHeaderTitle: {
    fontSize: '18px !important',
    fontWeight: '500 !important',
  },
  widgetContent: {
    height: 305,
    maxHeight: 305,
    [theme.breakpoints.down('md')]: {
      height: 'auto',
    },
  },
  widgetContentFullHeight: {
    height: 'auto',
    maxHeight: 'none',
  },
  widgetContentStaticHeight: {
    [theme.breakpoints.down('md')]: {
      height: '305px !important',
    },
  },
  widgetContentScrollable: {
    overflowY: 'scroll !important',
  },
  widgetActionMenu: {
    marginLeft: -70,
  },
  widgetAction: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    marginRight: 0,
    marginLeft: 5,
  },
  widgetActionCustom: {
    marginTop: 3,
  },
}));

export default useStylesWidget;
